goog.module('yext.developerapps.hubspotreviewgen.init');
goog.module.declareLegacyNamespace();

const ReviewGenConfiguration = goog.require('yext.developerapps.hubspotreviewgen.ReviewGenConfiguration');

$(document).ready(function() {
  var initIdentifier = $('.js-hubspotreviewgen-init').data('jsinit');
  switch (initIdentifier) {
    case 'reviewgen-config':
      new ReviewGenConfiguration();
      break;
  }
});

